export enum FilterDefinitionTypeEnum {
  BOOLEAN = 'boolean',
  SELECT = 'select',
  ASYNC_SELECT = 'async_select',
  PERIOD = 'period',
  TEXT = 'text',
  // Adds more types as needed in the future (require UI components)
}

export interface FilterDefinitionOption {
  value: string | number;
  label: string;
}

/**
 * A boolean option a SELECT or ASYNC_SELECT filter carries alongside its values.
 * Its state travels inside the value list as a `~<name>:0|1` token; a value
 * carrying no token falls back to `default`.
 */
export interface FilterToggleDefinition {
  name: string;
  label: string;
  default: boolean;
}

export interface PresetDefinition {
  name: string;
  label: string;
}

export interface FilterDefinition {
  name: string;
  label: string;
  type: FilterDefinitionTypeEnum;
  isUnstacked?: boolean;
  options?: FilterDefinitionOption[];
  async?: AsyncFilterDefinition;
  /** SELECT and ASYNC_SELECT only: a boolean option offered alongside the values. */
  toggle?: FilterToggleDefinition | null;
  /**
   * SELECT and ASYNC_SELECT only: false offers a single choice. The value stays a
   * one-value list, so it travels and reads like any other select.
   */
  multiple?: boolean;
  presets?: PresetDefinition[];
  default?: string;
  /**
   * PERIOD only: pick a time alongside the date. Bounds are then exchanged as ISO 8601 rather
   * than Y-m-d, so a period shorter than a day stays unambiguous.
   */
  with_time?: boolean;
}

export interface AsyncFilterDefinition {
  model: string,
  /**
   * Base filters the options endpoint understands. Left out, every base filter
   * of the current list is forwarded; empty, none of them is.
   */
  allow_filters?: string[] | null,
  includes?: string[],
}

export interface Filters {
  [key: string]: string | null;
}

export interface FilterWithValue {
  filter: FilterDefinition;
  value: string | boolean | string[];
}
